module.exports = __webpack_public_path__ + "img/elementheights_jak.39fc395e.png";